import React from "react";
import Fin from "./index.js";
import { trackPage } from "../../../analytics";

export default props => {
  React.useEffect(() => {
    trackPage("fin-residential");
  }, []);

  return <Fin type="residential" {...props} />;
};
